import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Icon,
  Input,
  Text,
} from "@chakra-ui/react";
import { DropDown } from "../../components/Select/DropDown";
import { MdEditOff, MdModeEdit, MdSave } from "react-icons/md";
import { AiTwotoneApi } from "react-icons/ai";
import { Table } from "../../components/Table/Table";
import { IoMdAdd } from "react-icons/io";
import { useRecordType } from "./useRecordType";

export const RecordType = () => {
  const {
    selectedRecordType,
    isEditing,
    onEditToggle,
    isEdited,
    onSave,
    dataSources,
    selectedDataSource,
    setSelectedDataSource,
    recordName,
    setRecordName,
    tableName,
    setTableName,
    columns,
    columnData,
    onAddField,
    selectedTables,
    tableFieldsColumns,
    tableFieldsColumnsData,
  } = useRecordType();

  return (
    <Box>
      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        p={6}
      >
        <HStack justifyContent="space-between">
          <HStack>
            <Icon
              as={AiTwotoneApi as React.ElementType}
              color="#FF00FF"
              boxSize="24px"
            />
            <Heading fontSize="24px" color="white">{recordName}</Heading>
          </HStack>
          <HStack>
            <Icon
              as={
                isEditing
                  ? (MdEditOff as React.ElementType)
                  : (MdModeEdit as React.ElementType)
              }
              onClick={onEditToggle}
              cursor="pointer"
              boxSize="20px"
              color="rgba(255, 255, 255, 0.8)"
              _hover={{ color: "brand.400" }}
            />
            {isEdited ? (
              <Icon
                as={MdSave as React.ElementType}
                cursor="pointer"
                boxSize="20px"
                onClick={onSave}
                color="green.400"
                _hover={{ color: "green.300" }}
              />
            ) : null}
          </HStack>
        </HStack>
      </Box>

      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        p={6}
        mt={4}
      >
        <FormControl id="cs" mb={4}>
          <FormLabel color="white">Data Source</FormLabel>
          <DropDown
            selected={{
              id: selectedDataSource?.uuid as string,
              name: selectedDataSource?.dbSourceNm as string,
              component: (
                <Text>{selectedDataSource?.dbSourceNm as string}</Text>
              ),
            }}
            title={<Text></Text>}
            options={dataSources.map((ds, index) => ({
              id: ds.uuid,
              name: ds.dbSourceNm,
              component: <Text key={index}>{ds.dbSourceNm}</Text>,
            }))}
            onOptionChange={(option) => {
              if (!Array.isArray(option)) {
                setSelectedDataSource(
                  dataSources.find((ds) => ds.uuid === option.id)
                );
              }
            }}
            disabled={!isEditing}
          />
        </FormControl>

        <FormControl id="name" mb={4}>
          <FormLabel color="white">Name</FormLabel>
          <Input
            placeholder="Enter integration name"
            focusBorderColor="brand.500"
            value={recordName}
            onChange={(e) => setRecordName(e.target.value)}
            isReadOnly={!isEditing}
          />
        </FormControl>

        <FormControl id="tableName" mb={4}>
          <FormLabel color="white">Table Name</FormLabel>
          <DropDown
            selected={{
              id: tableName,
              name: tableName,
              component: <Text>{tableName}</Text>,
            }}
            title={<Text />}
            options={selectedTables?.map((table) => ({
              id: table,
              name: table,
              component: <Text>{table}</Text>,
            }))}
            onOptionChange={(option) => {
              if (!Array.isArray(option)) setTableName(option.id);
            }}
            disabled={!isEditing}
          />
        </FormControl>
      </Box>

      {tableFieldsColumnsData.length !== 0 && (
        <Box
          bg="rgba(255, 255, 255, 0.05)"
          backdropFilter="blur(20px)"
          borderRadius="20px"
          border="1px solid rgba(255, 255, 255, 0.1)"
          mt={4}
        >
          <Heading fontSize="22px" p={4} color="white">
            Record Fields
          </Heading>
          <Table data={tableFieldsColumnsData} columns={tableFieldsColumns} />
        </Box>
      )}
    </Box>
  );
};
